// extracted by mini-css-extract-plugin
module.exports = {"statsTable":"StatisticsPage_statsTable__2r4jq","datePickerWrapper":"StatisticsPage_datePickerWrapper__10P6u","clearDateICon":"StatisticsPage_clearDateICon__1cpar"};